import { useModal } from '@radical/hooks'
import { useFormilyForm } from '@radical/formily'
import { message } from 'ant-design-vue'
import { useI18n } from '@radical/locale'

const { t } = useI18n()

const { FormilyForm, form, submit } = useFormilyForm({
  schema: {
    type: 'object',
    properties: {
      layout: {
        type: 'void',
        'x-component': 'FormLayout',
        'x-component-props': {
          layout: 'horizontal',
          labelCol: 6,
          wrapperCol: 14,
        },
        properties: {
          oldpassword: {
            type: 'string',
            get title() {
              return t('common.旧密码')
            },
            'x-decorator': 'FormItem',
            'x-component': 'Password',
            'x-component-props': {
              get placeholder() {
                return t('common.请输入旧密码')
              },
              allowClear: true,
            },
            required: true,
          },
          password: {
            type: 'string',
            get title() {
              return t('common.新密码')
            },
            'x-decorator': 'FormItem',
            'x-component': 'Password',
            'x-component-props': {
              get placeholder() {
                return t('common.请输入新密码')
              },
              allowClear: true,
            },
            required: true,
            'x-validator': {
              validator: (value, rule, ctx) => {
                if (!value || !ctx.form.values?.password) return ''
                return ctx.form.values?.oldpassword === value
                  ? rule.message
                  : ''
              },
              get message() {
                return t('common.新密码不能与旧密码相同')
              },
            },
            'x-reactions': {
              dependencies: ['oldpassword'],
              fulfill: {
                run: "$values?.password2 && $form.validate('password2')",
              },
            },
          },
        },
      },
    },
  },
})
export const useUpdatePassWord = (userStore) => {
  useModal({
    content: () => <FormilyForm />,
    modalConfig: {
      get title() {
        return t('common.修改密码')
      },
      maskClosable: false,
      onOk: async () => {
        const formData = await submit()
        if (formData) {
          await userStore.updatePassWord(formData)
          message.success(t('common.密码修改成功'))
          return Promise.resolve(true)
        }
        return Promise.reject(false)
      },
      onClose: () => {
        // 重置表单
        form.reset()
      },
    },
  })
}
